<script setup lang="ts">
export interface PageViewProps {
  isStretched?: boolean
}
const props = defineProps<PageViewProps>()
</script>
<template>
  <div
    class="gwpageview"
    :class="{
      gwpageview_stretched: props.isStretched,
    }"
  >
    <div class="gwpageview_inner">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gwpageview {
  display: flex;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 0;
  min-width: 0;

  &:has([id^='Root-react-wrapper']) {
    background: var(--palette-paper-elevation0);
  }

  --gwpageview-max-width: 102rem;
  &_stretched {
    --gwpageview-max-width: 2160px;
  }
  &_inner {
    display: flex;
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding: 1rem;
    min-height: 24rem;
    margin: 0 auto;
    flex-direction: column;
    max-width: clamp(1px, var(--gwpageview-max-width), 100vw);
  }
}

@media (max-width: 1023px) {
  .gwpageview {
    &_inner {
      padding: 0.5rem;
    }
  }
}
</style>
